var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('ConnectionInfo'),_c('ProxyInfo'),_c('Scrutineer'),_c('VoteHistory'),_c('QRCode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }